// import React from "react";
// import { Paper, Typography, Button, Box } from "@mui/material";
// import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
// import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
// import EventIcon from "@mui/icons-material/Event";
// import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

// export default function QuickActions({ onAction = () => {} }) {
//   const baseBtnSx = {
//     textTransform: "none",
//     fontWeight: 500,
//     borderRadius: 999,
//     px: 2.5,
//     py: 0.75,
//     width: { xs: "100%", sm: "auto" },
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* Header */}
//       <Typography
//         variant="overline"
//         sx={{
//           fontSize: 11,
//           letterSpacing: 0.8,
//           textTransform: "uppercase",
//           color: "text.secondary",
//         }}
//       >
//         Actions
//       </Typography>
//       <Typography
//         variant="h6"
//         sx={{ fontWeight: 700, lineHeight: 1.2, mb: 1.5 }}
//       >
//         Quick Actions
//       </Typography>

//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", sm: "row" },
//           flexWrap: { xs: "nowrap", sm: "wrap" },
//           columnGap: 1.5,
//           rowGap: { xs: 1.5, sm: 2.5 },
//         }}
//       >
//         <Button
//           variant="contained"
//           color="primary"
//           startIcon={<AssignmentTurnedInIcon />}
//           onClick={() => onAction("createJob")}
//           sx={{
//             ...baseBtnSx,
//             boxShadow: "0 4px 12px rgba(37,99,235,0.25)",
//           }}
//         >
//           New JD
//         </Button>

//         <Button
//           variant="outlined"
//           startIcon={<PersonAddAltIcon />}
//           onClick={() => onAction("addCandidate")}
//           sx={baseBtnSx}
//         >
//           Add Candidate
//         </Button>

//         <Button
//           variant="outlined"
//           color="info"
//           startIcon={<EventIcon />}
//           onClick={() => onAction("scheduleEvent")}
//           sx={baseBtnSx}
//         >
//           Schedule Event
//         </Button>

//         <Button
//           variant="contained"
//           color="secondary"
//           startIcon={<WorkOutlineIcon />}
//           onClick={() => onAction("newJobOrder")}
//           sx={baseBtnSx}
//         >
//           New Job Order
//         </Button>
//       </Box>
//     </Paper>
//   );
// }


import React from "react";
import { Paper, Typography, Button, Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import EventIcon from "@mui/icons-material/Event";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export default function QuickActions({ onAction = () => {} }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const baseBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "12px",
    px: 2.5,
    py: 0.95,
    width: { xs: "100%", sm: "auto" },
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          color: muted,
          fontWeight: 500,
          fontFamily:
            '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        }}
      >
        Actions
      </Typography>

      <Typography
        sx={{
          mt: 0.6,
          mb: 1.75,
          fontWeight: 800,
          fontSize: "1.35rem",
          lineHeight: 1.15,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        Quick Actions
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          flexWrap: { xs: "nowrap", sm: "wrap" },
          columnGap: 1.5,
          rowGap: { xs: 1.25, sm: 1.5 },
        }}
      >
        <Button
          variant="contained"
          startIcon={<AssignmentTurnedInIcon />}
          onClick={() => onAction("createJob")}
          sx={{
            ...baseBtnSx,
            background: accent,
            color: "#fff",
            boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
            "&:hover": {
              background: accent,
              filter: "brightness(1.08)",
            },
          }}
        >
          New JD
        </Button>

        <Button
          variant="outlined"
          startIcon={<PersonAddAltIcon />}
          onClick={() => onAction("addCandidate")}
          sx={{
            ...baseBtnSx,
            borderColor: border,
            color: text,
            "&:hover": {
              borderColor: accent,
              color: accent,
              background: "transparent",
            },
          }}
        >
          Add Candidate
        </Button>

        <Button
          variant="outlined"
          startIcon={<EventIcon />}
          onClick={() => onAction("scheduleEvent")}
          sx={{
            ...baseBtnSx,
            borderColor: border,
            color: text,
            "&:hover": {
              borderColor: accent,
              color: accent,
              background: "transparent",
            },
          }}
        >
          Schedule Event
        </Button>

        <Button
          variant="outlined"
          startIcon={<WorkOutlineIcon />}
          onClick={() => onAction("newJobOrder")}
          sx={{
            ...baseBtnSx,
            borderColor: border,
            color: text,
            "&:hover": {
              borderColor: accent,
              color: accent,
              background: "transparent",
            },
          }}
        >
          New Job Order
        </Button>
      </Box>
    </Paper>
  );
}
